import type { ApiResponse } from "~/types/apiResponse";
import type { RefreshTokenResponse } from "~/types/auth";

export default defineNuxtPlugin(async () => {
  const { setAccessToken, setUser, clear } = useAuth();

  try {
    const response: ApiResponse<RefreshTokenResponse> = await useRefreshToken();
    if (response?.data && !response.error) {
      setAccessToken(response.data.accessToken as string);
      setUser(response.data.user);
    }
  } catch (error: unknown) {
    console.error(error);
    clear();
  }

  await useRedirect();
});
